// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconLabel_icon__GhuyK"};